// Marketplace side jobs API

import Swal from "sweetalert2";
import {
  ADDCANDIDATEPROFILE,
  APPLYFORJOB,
  GETALLJOB,
  GETALLJOBWITHCANDIDATEAPPLIED,
  GETCANDIDATEPROFILE,
  GETJOBSWITHCANDIDATEAPPLIED,
  UPDATECANDIDATEPROFILE,
} from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const getAllJobsMarketplace = async (payload, callback) => {
  await axios
    .post(GETALLJOB, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const getAllJob = async (payload, callback) => {
  await axios
    .post(GETALLJOBWITHCANDIDATEAPPLIED, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};
export const getJobProfile = async () => {
  const res = await axios.get(GETCANDIDATEPROFILE);
  return res;
};

export const updateJobProfile = async (payload, callback) => {
  await axios
    .post(UPDATECANDIDATEPROFILE, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addJobProfile = async (payload, callback) => {
  await axios
    .post(ADDCANDIDATEPROFILE, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const applyForJob = async (payload, callback) => {
  await axios
    .post(APPLYFORJOB, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Applied for job successfully",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};